import { render, staticRenderFns } from "./search.componentV2.vue?vue&type=template&id=6ab8d5fe&scoped=true&"
import script from "./search.componentV2.vue?vue&type=script&lang=js&"
export * from "./search.componentV2.vue?vue&type=script&lang=js&"
import style0 from "./search.componentV2.vue?vue&type=style&index=0&id=6ab8d5fe&scoped=true&lang=css&"
import style1 from "./search.componentV2.vue?vue&type=style&index=1&id=6ab8d5fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab8d5fe",
  null
  
)

export default component.exports